<template>
    <div class="ah-page current-expend-edit-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增經常性費用</h1>
                        <h1 v-if="form.sno">編輯經常性費用</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px" label-position="right">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">項目設定</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="iteM_NAM" label="項目名稱">
                            <el-input v-model="form.iteM_NAM" style="max-width: 400px" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="" required>
                            <template slot="label">
                                金額上限提示
                                <ah-tip>在請款時顯示，並不限制實際請款金額。</ah-tip>
                            </template>
                            <el-form-item prop="amT_S" style="display: inline-block" v-show="false">
                                <el-input v-model.number="form.amT_S" class="inline-input" style="max-width: 200px"></el-input>
                            </el-form-item>
                            <el-form-item prop="amT_E" style="display: inline-block">
                                <money-input v-model.number="form.amT_E" class="inline-input" />
                            </el-form-item>
                        </el-form-item>
                    </div>
                    <div class="panel-header small gray">
                        <div class="panel-title">審核流程設定</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="">
                            <div class="flow-editor">
                                <div class="flow-item">
                                    <span class="num">1</span>
                                    <span class="name">申請人</span>
                                </div>
                                <draggable v-model="form.auditFlowItems" draggable=".editable" animation="300">
                                    <div
                                        v-for="(element, index) in form.auditFlowItems"
                                        :key="index"
                                        :class="{
                                            'flow-item': element.menU_UNT != 'ADD',
                                            add_item: element.menU_UNT == 'ADD',
                                            editable: element.typ === 0
                                        }"
                                    >
                                        <el-button
                                            class="add-btn primary-action"
                                            round
                                            plain
                                            type="primary"
                                            v-if="element.menU_UNT === 'ADD' && !isQR()"
                                            icon="el-icon-plus"
                                            @click="addFlowMember(index)"
                                            >新增審核人</el-button
                                        >
                                        <p v-else-if="element.typ === 1">
                                            <span class="num">{{ index + 1 }}</span>
                                            <span class="name">
                                                <span v-if="element.menU_UNT == 'B02'">開立</span>
                                                <span v-else-if="element.menU_UNT == 'B03'">入帳</span>
                                                <span v-else-if="element.menU_UNT == 'A02'">填寫付款明細</span>
                                                <span v-else-if="element.menU_UNT == 'A03'">確認付款</span>
                                                <span v-else>{{ element.menU_UNT }}</span>
                                            </span>
                                        </p>
                                        <div v-else>
                                            <span class="num">{{ index + 2 }}</span>
                                            <el-select v-model="element.value" filterable no-match-text="找不到人員" placeholder="請選擇" @change="value => handleMemberSelect(value, index)">
                                                <el-option-group v-for="group in memberSelections" :key="group.label" :label="group.label">
                                                    <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                                </el-option-group>
                                            </el-select>
                                            <el-button v-if="!isQR()" class="del-btn" @click="deleteItem(index)"><i class="el-icon-delete"></i></el-button>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <center>
                    <el-button v-if="form.sno && !isQR()" type="danger" @click="deleteData">刪除</el-button>
                    <el-button type="normal" @click="onCancel">取消</el-button>
                    <el-button v-if="!isQR()" type="primary" @click="handleSubmit" class="primary-action">送出</el-button>
                </center>
            </el-form>
        </div>
    </div>
</template>
<script>
import ahTip from '@/components/ui/ahTip';
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
        ahTip,
    },
    props: {
        inputObject: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            form: {
                sno: null,
                iteM_NAM: '',
                amT_S: 0,
                amT_E: null,
                auditFlowItems: [],
                ofteN_FLAG: 1,
            },
            rules: {
                iteM_NAM: [
                    {
                        required: true,
                        message: '請輸入名稱',
                        tigger: 'blur',
                    },
                ],
                amT_S: [
                    {
                        type: 'number',
                        required: true,
                        message: '請輸入最小金額',
                        tigger: 'change',
                    },
                ],
                amT_E: [
                    {
                        type: 'number',
                        required: true,
                        message: '請輸入最大金額',
                        tigger: 'change',
                    },
                ],
            },
            memberSelections: [],
        };
    },
    created() {
        this.fetchAuditStaffOptions();
        if (this.$route.params.sno) this.fetchData();
        else this.fetchDefaultFlow();
    },
    methods: {
        fetchAuditStaffOptions() {
            this.$api({
                url: '/CurrentExpenditureSettingPage/GetAuditStaffOptions',
                method: 'GET',
            }).then((resp) => {
                this.memberSelections = [
                    {
                        label: '職位',
                        options: [
                            {
                                value: '1/主管',
                                label: '申請人主管',
                            },
                        ],
                    },
                    {
                        label: '指定人員',
                        options: resp.data.options
                            .filter((o) => o.grP_NO !== 'OT1')
                            .filter((o) => o.grP_NO !== 'OT2')
                            .filter((o) => o.grP_NO !== 'OT3')
                            .filter((o) => o.grP_NO !== 'OT4')
                            .map((x) => ({
                                value: `2/${x.sno}/${x.nam}`,
                                label: x.nam,
                            })),
                    },
                ];
            });
        },
        fetchData() {
            this.$api({
                url: `/CurrentExpenditureSettingPage/GetSettingDetail?Sno=${this.$route.params.sno}`,
                method: 'GET',
            }).then((resp) => {
                this.form = resp.data.setting;
                if (this.form.auditFlowItems.length === 0) {
                    this.$api({
                        url: '/CurrentExpenditureSettingPage/GetDefaultAuditFlow',
                        method: 'GET',
                    }).then((subResp) => {
                        this.form.auditFlowItems = subResp.data.auditFlowItems;
                    });
                } else {
                    this.form.auditFlowItems = this.form.auditFlowItems.map((x) => ({
                        ...x,
                        value: x.rolE_TYP === 1 ? '1/主管' : `2/${x.elsE_STF_SNO}/${x.menU_UNT}`,
                    }));
                }
            });
        },
        fetchDefaultFlow() {
            this.$api({
                url: '/CurrentExpenditureSettingPage/GetDefaultAuditFlow',
                method: 'GET',
            }).then((resp) => {
                this.form.auditFlowItems = resp.data.auditFlowItems;
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.form.auditFlowItems = this.form.auditFlowItems.filter((x) => !!x.rolE_TYP);
                    this.$api({
                        url: 'CurrentExpenditureSettingPage/UpsertSetting',
                        method: 'POST',
                        data: this.form,
                    }).then(() => {
                        this.$router.push({ name: 'current-expenditure' });
                    });
                } else {
                    this.scrollViewToError();
                }
            });
        },
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },
        addFlowMember(index) {
            this.form.auditFlowItems.splice(index, 0, {
                elsE_STF_SNO: null,
                menU_UNT: '',
                rolE_TYP: 0,
                sno: null,
                sot: 0,
                typ: 0,
            });
        },
        async deleteData() {
            try {
                await this.$confirm('確定要刪除嗎？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: `CurrentExpenditureSettingPage/DeleteSettings?SnoList=${this.form.sno}`,
                    method: 'DELETE',
                });

                this.$router.push({
                    name: 'current-expenditure',
                });
            } catch (e) {
                console.log(e);
            }
        },
        handleMemberSelect(value, index) {
            const datas = value.split('/');
            if (datas[0] === '1') {
                this.form.auditFlowItems[index].rolE_TYP = parseInt(datas[0]);
                this.form.auditFlowItems[index].menU_UNT = datas[1];
            } else if (datas[0] === '2') {
                this.form.auditFlowItems[index].rolE_TYP = parseInt(datas[0]);
                this.form.auditFlowItems[index].elsE_STF_SNO = datas[1];
                this.form.auditFlowItems[index].menU_UNT = datas[2];
            }
        },
        deleteItem(index) {
            this.form.auditFlowItems.splice(index, 1);
        },
        onCancel() {
            this.$router.push({ name: 'current-expenditure' });
        },
    },
};
</script>
<style lang="scss">
.current-expend-edit-page {
    .el-form {
        // max-width: 500px;
    }

    .inline-input {
        // max-width: 00px;
    }

    .el-form-item {
    }
}
</style>
